import { safeInternalReturnPath } from '@/utils/safeReturnPath';
import { readPurchaseIntent, purchaseDestination } from './purchaseIntent';

/** 明確目的地優先；只有未指定返回頁時才恢復已選商品。 */
export const resolveDmpPurchaseReturnPath = (requested?: string | null, owner?: string): string | null => {
  if (requested) return getDmpPurchaseReturnPath(requested);
  const intent = readPurchaseIntent(owner);
  return intent ? getDmpPurchaseReturnPath(purchaseDestination(intent)) : null;
};
export const withDmpPurchaseReturnPath = (destination: string, requested?: string | null): string => {
  const target = resolveDmpPurchaseReturnPath(requested);
  return target
    ? destination + (destination.includes('?') ? '&' : '?') + 'path=' + encodeURIComponent(target)
    : destination;
};

/** 只保留已實作的購買／付款結果頁，不接受任意登入轉址或巢狀 path。 */
export const getDmpPurchaseReturnPath = (requested?: string | null): string | null => {
  const safe = safeInternalReturnPath(requested);
  if (!safe) return null;
  const url = new URL(safe, window.location.origin);
  if (url.hash) return null;
  if (url.pathname === '/profile/subscriptionDetail' && !url.search) return safe;
  const params = url.searchParams;
  if (Array.from(params.keys()).some((key) => params.getAll(key).length !== 1)) return null;
  if (url.pathname === '/profile/plan-purchase') {
    if (Array.from(params.keys()).some((key) => key !== 'product')) return null;
    return ['individual', 'sme_firm', 'barrister', 'law_firm'].includes(params.get('product') || '') ? safe : null;
  }
  if (!/^\/(en|tc|sc)\/Subscription$/.test(url.pathname)) return null;
  if (Array.from(params.keys()).some((key) => !['purchase', 'payment', 'orderId', 'group'].includes(key))) return null;
  const purchase = params.get('purchase');
  const payment = params.get('payment');
  const order = params.get('orderId');
  const group = params.get('group');
  if (group !== null && !['free', 'standard', 'legal'].includes(group)) return null;
  if (purchase !== null && (!/^[a-z][a-z0-9_]{0,79}$/.test(purchase) || payment !== null || order !== null))
    return null;
  if (payment !== null && !['return', 'cancel'].includes(payment)) return null;
  if (order !== null && (payment === null || !/^[1-9][0-9]*$/.test(order) || !Number.isSafeInteger(Number(order))))
    return null;
  return safe;
};
